import React from "react";
import clsx from "clsx";
import { applyAlpha, } from "./helpers/applyAlpha";
import { ColorProps, } from "./types";
import useTheme from "./hooks/useTheme";

type LinearProgressProps = {
  value?: number; // 0–100 → determinate
  color?: ColorProps;
  height?: number; // px
  className?: string;
};

const trackColorMap = {
  primary: "bg-primary brightness-110",
  secondary: "bg-secondary brightness-110",
  inherit: "bg-current/20",
};

const barColorMap = {
  primary: "bg-primary",
  secondary: "bg-secondary",
  inherit: "bg-current",
};

export default function LinearProgress({
  value,
  color = "primary",
  height = 4,
  className,
}: LinearProgressProps): JSX.Element {
  const theme = useTheme();

  const selectedColor = theme.getColor(color);
  const isDeterminate = typeof value === "number";

  return (
    <div
      className={clsx(
        "relative w-full overflow-hidden rounded",
        trackColorMap[color],
        className
      )}
      style={{ height, backgroundColor: applyAlpha(selectedColor, 0.4) }}
    >
      {isDeterminate ? (
        <div
          className={clsx(
            "h-full transition-all duration-300 ease-linear",
            barColorMap[color]
          )}
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      ) : (
        <>
          <div
            className={clsx(
              "absolute h-full",
              barColorMap[color],
              "animate-linear-progress-1"
            )}
          />
          <div
            className={clsx(
              "absolute h-full",
              barColorMap[color],
              "animate-linear-progress-2"
            )}
          />
        </>
      )}
    </div>
  );
}